import {register} from '../vendor/theme-scripts/theme-sections';
import {Quickview} from '../features/quickview';
import popoutSection from '../features/popout';
import hideElement from '../util/hide-element';
import slideDown from '../util/slide-down';
import fadeIn from '../util/fade-in';

const selectors = {
  body: 'body',
  dataRelatedSectionElem: '[data-related-section]',
  dataRelatedProduct: '[data-product-grid-item]',
  dataProductId: 'data-product-id',
  dataLimit: 'data-limit',
  datTab: 'data-tab',
  dataTabIndex: 'data-tab-index',
  tabsLi: 'ul.tabs > li',
  tabLink: '.tab-link',
  tabLinkRecent: '.tab-link__recent',
  tabContent: '.tab-content',
  recentlyViewed: '#RecentlyViewed',
  recentlyProduct: '#recently-viewed-products .product-item',
};

const classes = {
  classCurrent: 'current',
  classHide: 'hide',
  classAlt: 'alt',
};

class Related {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.body = document.querySelector(selectors.body);
    this.accessibility = window.accessibility;

    this.init();
    this.tabs();
    this.recent();
  }

  init() {
    const relatedSection = this.container.querySelector(selectors.dataRelatedSectionElem);

    if (!relatedSection) {
      return;
    }

    const self = this;
    const productId = relatedSection.getAttribute(selectors.dataProductId);
    const limit = relatedSection.getAttribute(selectors.dataLimit);
    const requestUrl = `${window.theme.routes.product_recommendations_url}?section_id=related&limit=${limit}&product_id=${productId}`;
    const section = this.section;

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        const createdElement = document.createElement('div');
        createdElement.innerHTML = data;
        const inner = createdElement.querySelector(selectors.dataRelatedSectionElem);

        if (inner.querySelector(selectors.dataRelatedProduct)) {
          const innerHtml = inner.innerHTML;
          hideElement(relatedSection);
          relatedSection.innerHTML = innerHtml;
          slideDown(relatedSection);

          if (!Shopify.Products.hasProducts || !document.querySelector(selectors.recentlyViewed)) {
            new Quickview(section);
          }
        } else {
          self.hideRelatedTab();
        }
      })
      .catch(function () {
        self.hideRelatedTab();
      });
  }

  hideRelatedTab() {
    const relatedSection = this.container.querySelector(selectors.dataRelatedSectionElem);
    if (!relatedSection) {
      return;
    }

    const parentTabContent = relatedSection.closest(`${selectors.tabContent}.${classes.classCurrent}`);
    if (!parentTabContent) {
      return;
    }
    const parentTabContentIdx = parseInt(parentTabContent.getAttribute(selectors.dataTabIndex));
    const tabsNavList = this.container.querySelectorAll(selectors.tabsLi);

    if (tabsNavList.length > parentTabContentIdx) {
      const nextTabsNavLink = tabsNavList[parentTabContentIdx].nextSibling;

      if (nextTabsNavLink) {
        tabsNavList[parentTabContentIdx].classList.add(classes.classHide);
        nextTabsNavLink.dispatchEvent(new Event('click'));
      }
    }
  }

  tabs() {
    const ctx = this.container;
    const tabsNavList = ctx.querySelectorAll(selectors.tabsLi);
    const firstTabLink = ctx.querySelector(`${selectors.tabLink}-0`);
    const firstTabContent = ctx.querySelector(`${selectors.tabContent}-0`);

    if (firstTabContent) {
      firstTabContent.classList.add(classes.classCurrent);
    }

    if (firstTabLink) {
      firstTabLink.classList.add(classes.classCurrent);
    }

    this.checkVisibleTabLinks();

    if (tabsNavList.length) {
      tabsNavList.forEach((element) => {
        const tabId = parseInt(element.getAttribute(selectors.datTab));
        const tab = ctx.querySelector(`${selectors.tabContent}-${tabId}`);

        element.addEventListener('click', () => {
          this.tabChange(element, ctx, tab);
        });

        element.addEventListener('keyup', (event) => {
          if ((event.which === window.theme.keyboardKeys.SPACE || event.which === window.theme.keyboardKeys.ENTER) && this.body.classList.contains('is-focused')) {
            this.tabChange(element, ctx, tab);

            if (tab.querySelector('a, input')) {
              this.accessibility.lastFocused = element;

              this.accessibility.a11y.trapFocus(tab, {
                elementToFocus: tab.querySelector('a:first-child, input:first-child'),
              });
            }
          }
        });
      });
    }
  }

  tabChange(element, ctx, tab) {
    ctx.querySelector(`${selectors.tabsLi}.${classes.classCurrent}`).classList.remove(classes.classCurrent);
    ctx.querySelector(`${selectors.tabContent}.${classes.classCurrent}`).classList.remove(classes.classCurrent);

    element.classList.add(classes.classCurrent);
    tab.classList.add(classes.classCurrent);

    if (element.classList.contains(classes.classHide)) {
      tab.classList.add(classes.classHide);
    }

    this.checkVisibleTabLinks();

    this.accessibility.a11y.removeTrapFocus();
  }

  checkVisibleTabLinks() {
    const tabsNavList = this.container.querySelectorAll(selectors.tabsLi);
    const tabsNavListHided = this.container.querySelectorAll(`${selectors.tabLink}.${classes.classHide}`);
    const difference = tabsNavList.length - tabsNavListHided.length;

    if (difference < 2) {
      this.container.classList.add(classes.classAlt);
    } else {
      this.container.classList.remove(classes.classAlt);
    }
  }

  recent() {
    const self = this;
    const section = this.section;
    const recentlyViewed = document.querySelector(selectors.recentlyViewed);
    let howManyToshow = 4;

    if (recentlyViewed) {
      howManyToshow = parseInt(recentlyViewed.getAttribute(selectors.dataLimit));
      Shopify.Products.recordRecentlyViewed();
    }

    Shopify.Products.showRecentlyViewed({
      howManyToShow: howManyToshow,
      onComplete: function () {
        const recentProductsCount = document.querySelectorAll(selectors.recentlyProduct).length;

        if (recentProductsCount > 0) {
          fadeIn(recentlyViewed);

          const tabLink = document.querySelector(selectors.tabLinkRecent);

          if (tabLink) {
            tabLink.classList.remove(classes.classHide);
            const tabLinkIdx = parseInt(tabLink.getAttribute(selectors.datTab));
            const tabContent = document.querySelector(`${selectors.tabContent}[${selectors.dataTabIndex}="${tabLinkIdx}"]`);
            if (tabContent) {
              tabContent.classList.remove(classes.classHide);
            }

            self.checkVisibleTabLinks();
          }

          new Quickview(section);
        }
      },
    });
  }
}

const relatedSection = {
  onLoad() {
    this.section = new Related(this);
    new Quickview(this);
  },
  onUnload: function () {
    if (typeof this.section.unload === 'function') {
      this.section.unload();
    }
  },
};

register('related', [relatedSection, popoutSection]);
